document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll("a.pageselectfornview");

  links.forEach(link => {
     
              
    link.addEventListener("click", (event) => {
      event.preventDefault();
       const hrefFilter = link.getAttribute("href");
      console.log(`hrefFilter`, hrefFilter);

      
      localStorage.setItem("lastClickedLink", hrefFilter); // Save href to localStorage
      window.location.href = hrefFilter; // Navigate to the link
      
    });
  });
});

$(document).ready(function(){
  $(".tm-model-list").owlCarousel({
    responsiveClass:true,
    margin:10,
    nav: true,
    responsive:{
        200:{
            items:2
        },
        600:{
            items:3
        },
        1000:{
            items:4
        }
    }
  });
});


